<div class="mx-auto max-w-7xl px-4 py-7 sm:px-6 lg:px-8">
  <div class="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-12 mt-8">
    <div class="lg:col-span-6 h-full">
      @if (canAccessDevices) {
        <div class="card bg-base-100 dark:bg-black dark:border-1 dark:border-base-100 shadow-sm">
          <div class="card-body flex">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Nodes</h2>
            <p>Register or deregister your node.</p>
            <div class="card-actions mt-4">
              <a routerLink="/devices" class="btn btn btn-outline btn-primary bg-base-100 hover:bg-base-300 hover:text-primary dark:bg-black">
                <span>Nodes</span>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                  <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
      @if (canAccessAlmanac) {
        <div class="card bg-base-100 shadow-sm mt-6 dark:bg-black dark:border-1 dark:border-base-100 ">
          <div class="card-body flex">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Almanac Tools</h2>
            <p>Download the latest LoneWhisper almanac for testing.</p>
            <div class="card-actions mt-4">
              <a routerLink="/almanac" class="btn btn btn-outline btn-primary bg-base-100 dark:bg-black hover:bg-base-300 hover:text-primary">
                <span>Almanac Tools</span>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                  <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
      @if (canAccessDownloads) {
        <div class="card bg-base-100 shadow-sm mt-6 dark:bg-black dark:border-1 dark:border-base-100 ">
          <div class="card-body flex">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Docs</h2>
            <p>Here you'll find supporting documents and guides.</p>
            <div class="card-actions mt-4">
              <a href="/docs" class="btn btn btn-outline btn-primary bg-base-100 dark:bg-black hover:bg-base-300 hover:text-primary">
                <span>Docs</span>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                  <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="sm:mx-0 sm:rounded-lg lg:col-span-6">
      @if (canAccessPassPrediction) {
        <div class="card bg-base-100 shadow-sm dark:bg-black dark:border-1 dark:border-base-100 ">
          <div class="card-body">
            <div class="flex justify-between">
              <h2 class="text-2xl font-bold text-primary dark:text-white">Pass Prediction</h2>
            </div>
            <p>Find out when the next satellite passes overhead.</p>
            <div class="card-actions mt-4">
              <a routerLink="/pass_prediction" class="btn btn btn-outline btn-primary bg-base-100 dark:bg-black hover:bg-base-300 hover:text-primary">
                <span>Pass Prediction</span>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                  <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
      @if (canAccessDeliveryStatus) {
        <div class="card bg-base-100 shadow-sm mt-6 dark:bg-black dark:border-1 dark:border-base-100 ">
          <div class="card-body flex">
            <h2 class="text-2xl font-bold text-primary dark:text-white">Service Status</h2>
            <p>Check the status of our services and connected 3rd party endpoints.</p>
            <div class="card-actions mt-4">
              <a routerLink="/delivery_status" class="btn btn btn-outline btn-primary bg-base-100 dark:bg-black hover:bg-base-300 hover:text-primary">
                <span>Service Status</span>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                  <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }
      @if (canAccessAds) {
        <div class="card bg-base-100 shadow-sm mt-6 dark:bg-black dark:border-1 dark:border-base-100 ">
          <div class="card-body">
            <h2 class="text-2xl font-bold text-primary dark:text-white">ADS</h2>
            <p>Register or deregister your gateways used for the Almanac Distribution System</p>
            <div class="card-actions mt-4">
              <a routerLink="/ads" class="btn btn btn-outline btn-primary bg-base-100 hover:bg-base-300 dark:bg-black hover:text-primary">
                <span>ADS</span>
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-1">
                  <path d="M0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L5.28027 4.21973C5.57311 4.51262 5.57315 4.9874 5.28027 5.28027L1.28027 9.28027C0.987399 9.57315 0.512624 9.57311 0.219727 9.28027C-0.0731665 8.98738 -0.0731666 8.51262 0.219727 8.21973L3.68945 4.75L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727Z" fill="#7B35C6"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }

    </div>
  </div>
</div>
